import { c as _c } from "react/compiler-runtime";
import type { ComponentType, ReactNode } from 'react';
import { Text } from '@extern/ui/text';
import { GiftIcon } from '@phosphor-icons/react';
import Image from 'next/image';
import { useGetFeatureFlag } from '@/lib/feature-flags/hooks/use-get-feature-flag';
import GiftImg from '@/public/images/img-gift.png';
import { GIFT_AMOUNT_OPTIONS, GIFT_AMOUNT_PRICES, type GiftAmount, GiftCampaignEnums, type GiftCampaignName } from '../_utils/schema';
import { BlackFridayGiftHeader } from './blackfriday/header';
import { BLACKFRIDAY_GIFT_AMOUNT_OPTIONS, BLACKFRIDAY_GIFT_AMOUNT_PRICES } from './blackfriday/schema';
function DefaultGiftHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-4 rounded-3xl bg-contain bg-right bg-role-info-container bg-no-repeat px-6 py-6 md:gap-2 md:bg-[url('/images/bgr-gift.png')] md:py-12"><div className="hidden h-12 w-12 flex-col items-center justify-center gap-2 rounded-full bg-white text-role-on-info-container md:flex"><GiftIcon className="h-6 w-6" weight="fill" /></div><Image alt="Gift" className="mx-auto md:hidden" height={156} src={GiftImg} width={158} /><Text className="text-center font-normal text-role-on-info-container md:max-w-1/2 md:text-left md:text-[36px] md:leading-[44px]" heading="lg">Gift a subscription</Text><Text className="text-center text-[18px] text-role-on-info-container leading-[24px] md:max-w-1/2 md:text-left">Give the gift of professional experience and career growth</Text></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface CampaignConfig {
  Header: ComponentType;
  options: {
    value: GiftAmount;
    label: string | ReactNode;
  }[];
  prices: Record<GiftAmount, number>;
}
const campaignsRegistry: Partial<Record<GiftCampaignName, CampaignConfig>> = {
  [GiftCampaignEnums.BLACKFRIDAY_2025]: {
    options: BLACKFRIDAY_GIFT_AMOUNT_OPTIONS,
    prices: BLACKFRIDAY_GIFT_AMOUNT_PRICES,
    Header: BlackFridayGiftHeader
  }
};
const defaultCampaignConfig: CampaignConfig = {
  options: GIFT_AMOUNT_OPTIONS,
  prices: GIFT_AMOUNT_PRICES,
  Header: DefaultGiftHeader
};
function isValidCampaignName(campaignName: unknown): campaignName is GiftCampaignName {
  return typeof campaignName === 'string' && (Object.values(GiftCampaignEnums) as string[]).includes(campaignName) && campaignName in campaignsRegistry;
}
export function useCampaign() {
  const $ = _c(5);
  const campaignName = useGetFeatureFlag("ff_gift_campaign") as GiftCampaignName | undefined;
  const isValidCampaign = isValidCampaignName(campaignName);
  const campaignConfig = isValidCampaign && campaignsRegistry[campaignName] ? campaignsRegistry[campaignName] : defaultCampaignConfig;
  const t0 = isValidCampaign ? campaignName : undefined;
  let t1;
  if ($[0] !== campaignConfig.Header || $[1] !== campaignConfig.options || $[2] !== campaignConfig.prices || $[3] !== t0) {
    t1 = {
      options: campaignConfig.options,
      prices: campaignConfig.prices,
      Header: campaignConfig.Header,
      campaignName: t0
    };
    $[0] = campaignConfig.Header;
    $[1] = campaignConfig.options;
    $[2] = campaignConfig.prices;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}